import React from 'react';
import { useParams } from 'react-router-dom';
import Footer from './Footer';
import BackLink from './BackLink';
import './Blog.css';

const BlogPost = () => {
  const { id } = useParams();

  const blogPosts = {
    'panda-story': {
      title: 'The Story Behind Panda',
      date: 'January 2025',
      category: 'Story',
      readTime: '5 min read',
      imageUrl: '/panda-story.png',
      content: `🚀 Panda got 26K users in 15 days.

Wanted to share the story behind it, and the people who helped along the way.

People often think I built it solo, but truth is, I didn't.
Many helped in ways that mattered more than code.

A senior once told me:
"Build something so ambitious that smart people feel compelled to help you make it real."
That line stuck.

So, in my spare time, I started tinkering with a simple open-source side project, a voice assistant that could someday go beyond Siri or Google Assistant.
Something that could use any app, listen, and talk back like a real assistant.

Went through 30–40 GitHub repos and research papers for a week,
Built the 1st version in 10 days, it wished my brother happy b'day… in 5 mins 😅

Then came a 48-hr hackathon.
Brought that 5-min wish time down to 2.

Didn't win, but a judge DM'd me: "Super awesome project."
That meant more than a trophy.
Still grateful to Ariel Weinberger for organizing it, Panda needed that push.

After the hackathon, I kept improving Panda and started posting updates on Reddit.
Some posts went viral, repo hit 500⭐.

That's when I ran out of API credits, and Bennie Seybold noticed the project.
He helped me with Anthropic credits, which honestly kept Panda alive during that phase.

Around the same time, a French user named Tom started DM'ing feedback and bug reports. He believed in the project so much that he even volunteered to manage 
Panda's Instagram and Facebook pages.
People like him made it impossible to stop working on it.

By v4, Panda was wishing birthdays in 20 sec and handling long-range tasks, like DM'ing your new LinkedIn connections.

Then one night, I got an email from HowToMen.
He wanted to feature Panda in his video.
The video dropped, and Panda crashed within 15 min 😭
2K new users hit at once, and my infra collapsed.

People paid for Pro, got nothing.
Comments called it a scam.
Play Store reviews tanked.
I felt gutted.

Then my MDG Space, IITR alum group stepped in.
Kaustubh Trivedi revived the app.

When it crashed again, Madhur Rao jumped in.

Panda wouldn't exist without them.

Fun bit: I told Madhur it costs 6 K/day to run Panda.
He thought $6 K, and still agreed 😅
(It was ₹6 K.)

Just a small open-source side project I hacked together after hours, but it taught me something huge:
You can build the product yourself,
but it takes people to keep it alive. 💙

Also thanks to my brother, Ansh Chaudhary for being my unpaid intern, who sent me Briyani payment requests instead of invoices.

Also thanks to Harshita Singh, Usman Khatri, Dhanush Sugganahalli, @jules, @cursor, @kiro for contributing !!

PS. Thank you reading this far, if you know someone with Visual Impairment, please reach out!`
    },
    'accessibility-focus': {
      title: 'Beyond Screen Readers: Our Vision for True AI Accessibility',
      date: 'October 2025',
      category: 'Mission',
      readTime: '4 min read',
      imageUrl: '/nab-delhi.png',
      content: `I recently had the privilege of meeting with the people over at NAB Delhi (National Association for the Blind). These are people who live and breathe digital accessibility every day, so their feedback is invaluable.

It was a deeply encouraging session. The team's commendation for the initiative helped crystallize exactly why our approach is so different.

For years, digital accessibility has been defined by passive tools. Screen readers like TalkBack are life-changing, but they still place the full burden of navigation on the user. As the NAB team knows all too well, you have to learn complex gestures, remember app layouts, and listen to every single UI element just to get something done.

Panda is built on a different philosophy entirely. It’s designed to be an active agent instead of a passive reader.

What does this mean in practice? It means shifting the work from the user to the AI.

Instead of a user having to tap, tap, swipe through an app, they can simply state their goal: "Panda, book me an Uber from home to Connaught Place," or "Find the latest email from my bank and read it to me."

Panda sees the screen and operates the app to achieve that goal. It performs the taps, swipes, and text entries a sighted person would.

This is the fundamental difference the seasoned team at NAB Delhi recognized. It’s about understanding user intent and taking action.

This is our vision for the future of accessibility. A future where technology is a true assistant that handles the task, not just another interface to be learned. Having this vision validated by such dedicated experts is a powerful milestone for the entire project. I'm incredibly grateful for their time and insightful feedback.`
    }
  };

  const post = blogPosts[id];

  if (!post) {
    return (
      <div className="story-page">
        <div className="story-inner story-missing">
          <h1>Blog post not found</h1>
          <BackLink to="/blog" className="story-back">Blog</BackLink>
        </div>
        <Footer />
      </div>
    );
  }

  const paragraphs = post.content.split('\n\n').filter((p) => p.trim());

  return (
    <div className="story-page">
      <article className="story-inner">
        <BackLink to="/blog" className="story-back">Blog</BackLink>
        <h1>{post.title}</h1>
        <p className="news-meta">
          <span>{post.category}</span>
          <span>{post.date}</span>
          <span>{post.readTime}</span>
        </p>
        {post.imageUrl && (
          <figure className="story-figure">
            <img src={post.imageUrl} alt="" />
          </figure>
        )}
        <div className="story-body">
          {paragraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
        </div>
      </article>
      <Footer />
    </div>
  );
};

export default BlogPost;
